// Module
var code = "<h1 class=\"heading--isInteriorPageSubHeadingLeft\"> Payment Related Forms </h1> <p>Repay your loan in a way that is most convenient for you.</p> ";
// Exports
export default code;